import React from 'react';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { Checkbox, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import StickyHeadTable from 'shared/components/table/StickyHeadTable';
import { InfoModal } from 'shared/components/abstract/interactables';
import { BUTTON_COLORS } from 'shared/constants';
import { getUserGroupPath } from 'shared/routes/admin';
import { UserTableWrapper } from './styled';

function removeIcon(row, onDelete, groupName) {
  return (
    <InfoModal
      tip="Remove employee from group"
      icon={PersonRemoveIcon}
      className="trash"
      message="Remove user from group"
      title="Remove User"
      actionName="Remove"
      color={BUTTON_COLORS.error}
      description={<p>{`This will remove ${row.employee.fullname} from "${groupName}". Are you sure?`}</p>}
      actionCallback={() => (onDelete(row.id))}
    />
  );
}

function setManager(group, updateEmployeeFromUserGroup, isAdmin) {
  return (
    <Checkbox
      value={group.id}
      checked={group.currentEmployee.manager}
      disabled={!isAdmin}
      onChange={() => {
        updateEmployeeFromUserGroup(group.currentEmployee.id, {
          ...group.currentEmployee,
          manager: !group.currentEmployee.manager,
        });
      }}
    />
  );
}

function groupLink(id, name) {
  return <Link to={getUserGroupPath(id)}>{name}</Link>;
}

/**
 * @param {Object} props
 * @param {Array<Object>} props.currentGroups
 * @param {Function} props.removeFromUserGroup
 * @param {Function} props.updateEmployeeFromUserGroup
 * @param {boolean} props.isAdmin
 * @param {boolean} props.readOnly
 */
export default function UserGroupTable({
  currentGroups,
  removeFromUserGroup,
  updateEmployeeFromUserGroup,
  isAdmin,
  readOnly,
}) {
  const columns = [
    {
      name: 'Group name',
      formatter: (g) => (isAdmin
        ? groupLink(g.id, g.group_name)
        : <Typography>{g.group_name}</Typography>),
    },
  ];

  if (!readOnly) {
    columns.push(
      {
        name: 'Manager',
        formatter: (group) => setManager(group, updateEmployeeFromUserGroup, isAdmin),
      },
      {
        name: 'Remove',
        formatter: (group) => removeIcon(
          group.currentEmployee,
          removeFromUserGroup,
          group.group_name,
        ),
      },
    );
  }

  return (
    <UserTableWrapper>
      <StickyHeadTable
        columns={columns}
        noRowsText=""
        rowId="id"
        rows={currentGroups}
        striped
      />
    </UserTableWrapper>
  );
}
